import { render, staticRenderFns } from "./CountNotContentAudits.vue?vue&type=template&id=38b1c9ed&scoped=true&"
import script from "./CountNotContentAudits.vue?vue&type=script&lang=ts&"
export * from "./CountNotContentAudits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1c9ed",
  null
  
)

export default component.exports